import { SquarePen } from 'lucide-react';
import {
  FLOATING_HEADER_ICON,
  FLOATING_HEADER_ICON_BUTTON,
  FLOATING_HEADER_ICON_STROKE,
  HEADER_ICON_BUTTON,
} from '@/shared/ui-class';
import { useChat } from '@/versions/v1/shared/ChatContext';

type Variant = 'default' | 'floating';

export function NewConversationButton({ variant = 'default' }: { variant?: Variant }) {
  const { newChat } = useChat();

  if (variant === 'floating') {
    return (
      <button
        type="button"
        onClick={() => newChat()}
        aria-label="New chat"
        title="New chat"
        className={FLOATING_HEADER_ICON_BUTTON}
      >
        <SquarePen
          className={FLOATING_HEADER_ICON}
          strokeWidth={FLOATING_HEADER_ICON_STROKE}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => newChat()}
      aria-label="New conversation"
      title="New conversation"
      className={HEADER_ICON_BUTTON}
    >
      <SquarePen className="h-4 w-4" />
    </button>
  );
}
